import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { CxShippingConditionEntity, CxShippingConditionState } from './store/reducers/cx-shipping-condition.reducer';
import { CxApiMetadataService, CxApiMetadataStrategy } from '../cx-api-metadata/cx-api-metadata.service';
import { CxShippingConditionsRequest } from './store/actions/cx-shipping-condition.actions';
import * as cxShippingConditionSelector from './store/selectors/cx-shipping-condition.selector';
import CxShippingConditionAction from './store/actions/cx-shipping-condition.actions';
import { CxApiMetadataEntity } from '../cx-api-metadata/store/reducers/cx-api-metadata.reducer';

@Injectable({
  providedIn: 'root',
})
export class CxShippingConditionService {
  constructor(
    private store: Store<CxShippingConditionState>,
    private cxApiMetadata: CxApiMetadataService,
  ) {}

  public selectShippingConditions$(productTypeRequest: CxShippingConditionsRequest, strategy?: CxApiMetadataStrategy) {
    return this.cxApiMetadata
      .connectMetadata$(CxShippingConditionAction.fetchEntity(productTypeRequest), strategy)
      .pipe(
        switchMap((metadata) =>
          this.store
            .select(cxShippingConditionSelector.selectCxShippingConditionsById(), { ids: metadata.entityIds })
            .pipe(
              filter((res) => res.length === metadata.entityIds.length),
              map((res) => [res, metadata] as [CxShippingConditionEntity[], CxApiMetadataEntity]),
            ),
        ),
      );
  }

  public selectActive$() {
    return this.store.select(cxShippingConditionSelector.selectActiveCxShippingCondition);
  }

  public setActive(entityId: string | number) {
    return this.store.dispatch(CxShippingConditionAction.selectEntity({ id: `${entityId}` }));
  }
}
